<template>
  <div class="error-page-container">
    <div class="error-content">
      <div class="error-illustration">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Outer circle -->
          <circle cx="100" cy="100" r="80" stroke="#304BF7" stroke-width="2" fill="none"/>

          <!-- Background circle -->
          <circle cx="100" cy="100" r="78" fill="#EFF1FE" opacity="0.3"/>

          <!-- 404 Text at top -->
          <text x="100" y="50" text-anchor="middle" font-family="Arial, sans-serif" font-size="24" font-weight="700" fill="#39374D">404</text>

          <!-- Chart bars -->
          <rect x="65" y="85" width="6" height="20" fill="#304BF7" opacity="0.7" rx="1"/>
          <rect x="75" y="75" width="6" height="30" fill="#304BF7" opacity="0.9" rx="1"/>
          <rect x="85" y="70" width="6" height="35" fill="#304BF7" rx="1"/>
          <rect x="95" y="80" width="6" height="25" fill="#304BF7" opacity="0.8" rx="1"/>
          <rect x="105" y="65" width="6" height="40" fill="#304BF7" rx="1"/>
          <rect x="115" y="75" width="6" height="30" fill="#304BF7" opacity="0.9" rx="1"/>
          <rect x="125" y="85" width="6" height="20" fill="#304BF7" opacity="0.7" rx="1"/>

          <!-- Exclamation mark -->
          <circle cx="100" cy="130" r="15" fill="#304BF7" opacity="0.1"/>
          <rect x="98" y="120" width="4" height="12" fill="#304BF7" rx="2"/>
          <circle cx="100" cy="138" r="2" fill="#304BF7"/>

          <!-- Bottom text -->
          <text x="100" y="165" text-anchor="middle" font-family="Arial, sans-serif" font-size="10" font-weight="500" fill="#6B7280" opacity="0.8">PAGINA NON TROVATA</text>
        </svg>
      </div>

      <div class="error-text">
        <h1 class="error-title">Oops! Pagina non trovata</h1>
        <p class="error-description">
          La pagina che stai cercando non esiste o è stata spostata.
          Non preoccuparti, ti aiutiamo a tornare sulla strada giusta.
        </p>

        <div class="error-actions">
          <RouterLink to="/dashboard" class="btn-primary">
            Torna alla Dashboard
          </RouterLink>
          <button @click="goBack" class="btn-secondary">
            Torna Indietro
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorPage",
  methods: {
    goBack() {
      window.history.back();
    }
  }
});
</script>

<style scoped>
.error-page-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #EFF1FE 0%, #F8F9FF 100%);
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.error-content {
  max-width: 600px;
  text-align: center;
  background: white;
  padding: 3rem 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(48, 75, 247, 0.1);
  border: 1px solid rgba(48, 75, 247, 0.1);
}

.error-illustration {
  margin-bottom: 2rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.error-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #39374D;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.error-description {
  font-size: 1.125rem;
  color: #6B7280;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: #304BF7;
  color: white;
  padding: 0.875rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  border: 2px solid #304BF7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 160px;
}

.btn-primary:hover {
  background: #2A42E0;
  border-color: #2A42E0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(48, 75, 247, 0.3);
  color: white;
  text-decoration: none;
}

.btn-secondary {
  background: transparent;
  color: #39374D;
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  border: 2px solid #E5E7EB;
  cursor: pointer;
  min-width: 160px;
}

.btn-secondary:hover {
  background: #F9FAFB;
  border-color: #304BF7;
  color: #304BF7;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .error-page-container {
    padding: 1rem;
  }

  .error-content {
    padding: 2rem 1.5rem;
  }

  .error-title {
    font-size: 2rem;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 280px;
  }
}
</style>
